import { useAuthStore } from '@/plugins/w/auth/store/auth.store'

export function routerAuthGuard({ isAuthentificated, isNotAuthentificated, termsNotAccepted = null }, { to, from, next }) {
	const authStore = useAuthStore()

	if (to.meta.requiresAuth === true && isNotAuthentificated) {
		if (authStore.isLoggedIn) {
			if ((!authStore.getUser?.accepted_gtc || !authStore?.getUser.changed_password) && termsNotAccepted && to.name !== termsNotAccepted.name) return next(termsNotAccepted)

			return next()
		} else {
			return next(isNotAuthentificated)
		}
	} else if (to.meta.requiresAuth === false && isAuthentificated) {
		if (!authStore.isLoggedIn) return next()
		else return next(isAuthentificated)
	} else {
		return next()
	}
}
